import { render, staticRenderFns } from "./AlarmTable.vue?vue&type=template&id=a0a3d72a"
import script from "./AlarmTable.vue?vue&type=script&lang=js"
export * from "./AlarmTable.vue?vue&type=script&lang=js"
import style0 from "./AlarmTable.vue?vue&type=style&index=0&id=a0a3d72a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports